
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"89","height":"89","viewBox":"0 0 89 89","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.5 55.625C50.6442 55.625 55.625 50.6442 55.625 44.5C55.625 38.3558 50.6442 33.375 44.5 33.375C38.3558 33.375 33.375 38.3558 33.375 44.5C33.375 50.6442 38.3558 55.625 44.5 55.625Z","fill":"#4164E3"}}),_c('path',{attrs:{"d":"M74.1667 14.8327H62.4113L57.813 9.82643C56.4409 8.30602 54.4384 7.41602 52.3617 7.41602H36.6384C34.5617 7.41602 32.5592 8.30602 31.15 9.82643L26.5888 14.8327H14.8334C10.7542 14.8327 7.4167 18.1702 7.4167 22.2494V66.7494C7.4167 70.8285 10.7542 74.166 14.8334 74.166H74.1667C78.2459 74.166 81.5834 70.8285 81.5834 66.7494V22.2494C81.5834 18.1702 78.2459 14.8327 74.1667 14.8327ZM44.5 63.041C34.265 63.041 25.9584 54.7344 25.9584 44.4994C25.9584 34.2644 34.265 25.9577 44.5 25.9577C54.735 25.9577 63.0417 34.2644 63.0417 44.4994C63.0417 54.7344 54.735 63.041 44.5 63.041Z","fill":"#4164E3"}})])
          )
        }
      }
    